import { locationActions } from './actions-location'
import { userActions } from './actions-user'

export const actions = {
  ...locationActions,
  ...userActions,
}
